import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { apolloService } from '../../common/services'

import { DELETE_FAKE_BRAND_MUTATION } from '../graphql/mutations'
import { DELETE_FAKE_BRAND } from '../redux/action-types'

const useDeleteFakeBrandMutation = () => {
  const dispatch = useDispatch()

  const mutate = useCallback(
    id =>
      apolloService.mutate({
        mutation: DELETE_FAKE_BRAND_MUTATION,
        variables: { id },
        dispatch,
        action: DELETE_FAKE_BRAND,
      }),
    [dispatch],
  )

  return [mutate]
}

export default useDeleteFakeBrandMutation
